import { useState, useEffect } from 'react';

import { decryptor, encryptor } from '../utils/decryptor';

export default function useLocalStorage<ValueType>(
  key: string,
  defaultValue: ValueType,
): [ValueType, (newValue: ValueType) => void] {
  const [value, setValue] = useState(() => {
    const storedValue = localStorage.getItem(key);

    const decryptedData = decryptor(storedValue ?? '');

    return storedValue === null ? defaultValue : JSON.parse(decryptedData ?? '[]');
  });

  useEffect(() => {
    const listener = (e: StorageEvent): void => {
      if (e.storageArea === localStorage && e.key === key) {
        setValue(e.newValue ? JSON.parse(e.newValue) : e.newValue);
      }
    };

    globalThis.addEventListener('storage', listener);

    return () => {
      globalThis.removeEventListener('storage', listener);
    };
  }, [key, defaultValue]);

  const setValueInLocalStorage = (newValue: ValueType): void => {
    setValue((currentValue: any) => {
      const result = typeof newValue === 'function' ? newValue(currentValue) : newValue;

      const encryptedData = encryptor(JSON.stringify(result));

      localStorage.setItem(key, encryptedData ?? '[]');

      return result;
    });
  };

  return [value, setValueInLocalStorage];
}
